import React from 'react';
import PropTypes from 'prop-types';
import CheckboxInput from 'components/Credit24/Core/Controls/CheckboxInput';
import { FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import { loansData } from 'consts/loan/AU';
import LoanSection from './LoanSection';

const propTypes = {
  loanPaymentsFrequencies: PropTypes.array.isRequired,
  loanTypes: PropTypes.array.isRequired,
  hasPayAdvanceLoans: PropTypes.bool,
  hasCreditCards: PropTypes.bool,
  hasSmallLoans: PropTypes.bool,
  hasHomeLoans: PropTypes.bool,
  hasOtherLoans: PropTypes.bool,
};

const LoansAU = (props) => {
  const {
    loanPaymentsFrequencies,
    loanTypes,
  } = props;

  return (
    <>
      {loansData.map((section) => (
        <LoanSection
          key={section.name}
          {...section}
          hasFlag={props[section.hasFlagProp]}
          loanTypes={loanTypes}
          paymentFrequencies={loanPaymentsFrequencies}
        />
      ))}
      <br />
      <Field
        name="creditBureauEnquiries"
        component={CheckboxInput}
        text={<FormattedMessage id="loans.field.creditBureauEnquiries" />}
      />
    </>
  );
};

LoansAU.propTypes = propTypes;

export default LoansAU;
